/// <amd-module name="Wit/WorkItemForm/Links/GitHub/GitHubDropdownLoadingCell" />
import { IVssPageContext } from "VSS/Platform/Context";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { Spinner } from "VSSUI/Spinner";
import * as React from "react";

interface IGitHubDropdownLoadingCellProps {
    pageContext: IVssPageContext;
    loadingLabel: string;
    onShow: () => void;
}

export const GitHubDropdownLoadingCell: React.FC<IGitHubDropdownLoadingCellProps> = props => {
    const [isIntersecting, setIsIntersecting] = React.useState(false);
    const ref = React.useRef(null);
    const useDropdownListComponentFFEnabled = React.useMemo(
        () => isFeatureFlagEnabled(props.pageContext, "VisualStudio.Services.WebPlatform.UseDropdownListComponent", false),
        []
    );

    React.useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            setIsIntersecting(entry.isIntersecting);
        });
        ref.current && observer.observe(ref.current);

        return () => observer.disconnect();
    }, []);

    React.useEffect(() => {
        if (isIntersecting) {
            props.onShow();
        }
    }, [isIntersecting]);

    const spinner = <Spinner label={props.loadingLabel} />;

    return useDropdownListComponentFFEnabled ? <div ref={ref}>{spinner}</div> : <td ref={ref}>{spinner}</td>;
};
